import { injectIntl } from 'react-intl';
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import { createStructuredSelector } from 'reselect';
import { fetchVehicle } from '../actions';
import { REQUEST_VEHICLE } from '../constants';
import { selectWork } from '../../Api/selectors';
import { selectVehicle } from '../selectors';
import { EditVehicleOptions } from '../pages/create/OptionsStep/EditVehicleOptions';
import _ from 'lodash';

const Container = styled.div`
  width: 100%;

  .btn-block {
    padding: 30px;
  }
`;

const STATE = {
  string: '',
  active: false,
};

/* eslint-disable react/prefer-stateless-function */
class CopyOptionsEditComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch;
  }

  render() {
    return (
      <Container>
        <div className={'container-fluid info-card text-muted'}>
          <EditVehicleOptions vehicle={this.props.vehicle} />
        </div>
      </Container>
    );
  }
}

CopyOptionsEditComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE),
    vehicle: selectVehicle(ownProps.vehicle_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchVehicle(ownProps.vehicle_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CopyOptionsEdit = compose(withConnect, withRouter, injectIntl)(CopyOptionsEditComp);
